import { CosmosClient } from '@azure/cosmos';
import { createDuplicateVendorError, findMatchingVendor, normalizeVendorName } from '../utils/vendorUtils';

// Azure Cosmos DB configuration
const endpoint = process.env.REACT_APP_COSMOS_DB_URI;
const key = process.env.REACT_APP_COSMOS_DB_KEY;
const databaseId = process.env.REACT_APP_COSMOS_DB_ID;
const containerId = 'vendors';

const client = new CosmosClient({ endpoint, key });

const database = client.database(databaseId);
const container = database.container(containerId);

const findVendorByName = async (vendorName, ignoredVendorId = null) => {
    const { resources } = await container.items.readAll().fetchAll();
    return findMatchingVendor(resources, vendorName, ignoredVendorId);
};

// Function to insert vendor data into Cosmos DB
const insertVendor = async (vendorData) => {
    try {
        const vendorName = vendorData?.vendor?.toString().trim();

        if (!vendorName) {
            throw new Error('Vendor name is required');
        }

        const existingVendor = await findVendorByName(vendorName);

        if (existingVendor) {
            throw createDuplicateVendorError(existingVendor);
        }

        const { resource } = await container.items.create({
            ...vendorData,
            vendor: vendorName,
            normalizedVendorName: normalizeVendorName(vendorName),
        });
        return resource;
    } catch (error) {
        console.error('Error inserting vendor data:', error);
        throw error;
    }
};

// Function to get all vendors from Cosmos DB
const getVendors = async () => {
    try {
        const { resources } = await container.items.readAll().fetchAll();
        return resources;
    } catch (error) {
        console.error('Error getting vendors:', error);
        throw error;
    }
};

const updateVendor = async (id, vendor, type, recurring) => {
    try {
        const vendorName = vendor?.toString().trim();

        if (!vendorName) {
            throw new Error('Vendor name is required');
        }

        const existingVendor = await findVendorByName(vendorName, id);

        if (existingVendor) {
            throw createDuplicateVendorError(existingVendor);
        }

        const { resource } = await container.items.upsert({
            id,
            vendor: vendorName,
            type,
            recurring,
            normalizedVendorName: normalizeVendorName(vendorName),
        });
        return resource;
    } catch (error) {
        console.error('Error updating vendor data:', error);
        throw error;
    }
};

const getCompanies = async () => {
    // return hardocded companies for now
    return [
        { id: '1', company: 'We Soda Ltd' },
        { id: '2', company: 'Soda World Ltd' },
    ];
};

const getVendorTypes = async () => {
    try {
        const { resources } = await container.items.query({
            query: 'SELECT DISTINCT c.type FROM c',
        }).fetchAll();

        // Map resources to the desired format
        let vendorTypes = resources.map((type, index) => ({ id: index + 1, type: type.type }));

        // Filter out null and empty string types
        vendorTypes = vendorTypes.filter((type) => type.type !== null && type.type !== '');

        // Add the "All" type to the beginning
        vendorTypes.unshift({ id: 0, type: 'All' });

        return vendorTypes;
    } catch (error) {
        console.error('Error getting vendor types:', error);
        throw error;
    }
};

export { insertVendor, getVendors, updateVendor, getCompanies, getVendorTypes, findVendorByName };
